import { memo, useCallback, useState } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryDelete.module.scss";
import { Icon } from "components/landingNew/shared/ui/Icon";
import { ReactComponent as TrashIcon } from "static/img/trash.svg";
import { SociometryDeleteModal } from "../SociometryDeleteModal/SociometryDeleteModal";

interface SociometryDeleteProps {
    className?: string;
    sessionId?: string;
    syncClasses?: (sessionId: string) => void;
}

export const SociometryDelete = memo((props: SociometryDeleteProps) => {
    const { className, sessionId, syncClasses } = props;

    const [openModal, setOpenModal] = useState<boolean>(false);

    const showModal = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        e.preventDefault();
        setOpenModal(true);
    }, []);

    const closeModal = useCallback(() => {
        setOpenModal(false);
    }, []);

    return (
        <div className={classNames(cls.sociometryDelete, {}, [className])}>
            <button
                className={classNames(cls.actionButton, {}, [])}
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => showModal(e)}
            >
                <Icon Svg={TrashIcon} width={20} height={20} className={cls.icon} />
            </button>
            <SociometryDeleteModal
                isOpen={openModal}
                onClose={closeModal}
                sessionId={sessionId || ""}
                syncClasses={syncClasses}
            />
        </div>
    );
});

SociometryDelete.displayName = "SociometryDelete";
